import React from "react";

// Shared trade data (source: websitedata2025.pdf).
export const TRADES = [
  {
    key: "electrician",
    nameMr: "वीजतंत्री",
    nameEn: "Electrician",
    qualification: "SSC Pass",
    duration: "2 Years",
    units: 4,
    intake: 80,
    accent: "#F97316",
    highlights: [
      "Detailed knowledge of the electrical sector — theory + practicals as per NCVT syllabus",
      "Maintenance & repair of three-phase, single-phase AC and DC motors",
      "Understanding, repair and maintenance of all AC & DC starters",
      "Domestic & industrial wiring installation and maintenance",
      "Panel wiring and motor rewinding in factories",
      "Generators, alternators, transformers — repair and installation",
      "Basic electronics fundamentals",
    ],
    prospects: [
      "Operator in MSEB / state electricity boards",
      "Electrician Assistant / Supervisor in factories",
      "Self-employment (contractor, panel builder, service unit)",
      "ST Corporation, Indian Railways, NTPC recruitments",
      "ITI Craft Instructor (Government / Private ITIs)",
    ],
  },
  {
    key: "fitter",
    nameMr: "जोडारी",
    nameEn: "Fitter",
    qualification: "SSC Pass",
    duration: "2 Years",
    units: 2,
    intake: 40,
    accent: "#EAB308",
    highlights: [
      "In-depth knowledge of machine tools and machining processes",
      "Marking, hacksawing, chipping, filing — bench-work fundamentals",
      "Drilling, reaming, tapping and dieing",
      "Precision measuring instruments — verniers, micrometers, gauges",
      "Basic operations on lathe machines",
      "Pipe fitting, hydraulic and pneumatic circuits",
      "Arc welding and gas welding (integrated with related trades)",
      "Machine maintenance and accuracy checking; jigs and fixtures",
    ],
    prospects: [
      "Fabrication workshop / machine-shop entrepreneur",
      "Maintenance department of large manufacturing companies",
      "Job Inspector / Quality Inspector roles",
      "ITI Craft Instructor",
      "Domestic plumbing and installation services",
    ],
  },
  {
    key: "mmv",
    nameMr: "यां. मोटारगाडी",
    nameEn: "Mechanic Motor Vehicle",
    qualification: "SSC Pass",
    duration: "2 Years",
    units: 2,
    intake: 48,
    accent: "#0EA5E9",
    highlights: [
      "In-depth automobile sector knowledge across 2W / 3W / 4W",
      "Petrol engines, Diesel engines, MPFI, CRDI — parts and diagnostics",
      "Engine repair, overhaul, testing and start-up",
      "Auto-electricals — battery, alternator, starter systems",
      "Wheel alignment, steering, transmission and braking systems",
      "Practical driving training",
    ],
    prospects: [
      "Automobile garage / authorised service centre (2W & 4W) entrepreneur",
      "Fuel-injection pump repair & calibration centre",
      "Craft Instructor (Govt. / Private ITIs)",
      "Automobile OEMs — Mahindra, Tata, Eicher, Hyundai, Bajaj, etc.",
      "Railways, ST Corporation — Mechanic grade posts",
    ],
  },
  {
    key: "diesel",
    nameMr: "यां. डिझेल",
    nameEn: "Mechanic Diesel",
    qualification: "SSC Pass",
    duration: "1 Year",
    units: 2,
    intake: 48,
    accent: "#DC2626",
    highlights: [
      "Focussed programme on diesel engines and heavy-vehicle powertrains",
      "MPFI, CRDI and modern diesel injection systems",
      "Engine strip-down, repair, testing and re-assembly",
      "Auto-electrical fundamentals — battery, alternator, starter",
      "Steering, transmission and braking system service",
      "Driving training included",
    ],
    prospects: [
      "Diesel garage & fuel-injection pump service centre",
      "Heavy vehicle / generator servicing units",
      "Craft Instructor roles in Govt. & Private ITIs",
      "Recruitment in Railways, ST Corporation, defence support units",
      "Automotive OEM shop-floor and service technician roles",
    ],
  },
];

// Activities from the brochure — page 13–16.
export const ACTIVITIES = [
  { title: "Expert Guidance", mr: "तज्ञाचे मार्गदर्शन", desc: "Regular guest lectures by domain experts from industry and academia." },
  { title: "Tree Plantation Drives", mr: "वृक्षारोपन", desc: "Annual tree plantation programmes on campus and in the surrounding villages." },
  { title: "Blood Donation Camps", mr: "रक्तदान शिबीराचे आयोजन", desc: "In association with Siddheshwar Blood Bank, Solapur — held every academic year." },
  { title: "Shivrajyabhishek Day", mr: "शिवराज्याभिषेक दिन", desc: "Celebration of Chhatrapati Shivaji Maharaj's coronation day with cultural programmes." },
  { title: "Partition Horrors Remembrance", mr: "विभाजन विभिषिका दिवस", desc: "Observance dedicated to the memory of India's partition." },
  { title: "Pandit Deendayal Upadhyay Jayanti", mr: "पंडित दिनदयाल उपाध्याय जयंती", desc: "Talks and reflection on Antyodaya and Integral Humanism." },
  { title: "Vijay Diwas", mr: "विजय दिवस", desc: "Commemoration of the 1971 victory with tributes to the armed forces." },
  { title: "Constitution Day (26 Nov)", mr: "संविधान दिन", desc: "Reading of the Preamble and awareness sessions on constitutional values." },
];

export const FACILITIES = [
  { title: "Spacious Grand Building", mr: "प्रशस्त भव्य ईमारत", desc: "Purpose-built ITI campus on Tuljapur Road with airy classrooms, workshops and administrative blocks." },
  { title: "Modern Computer Lab", mr: "प्रशस्त संगणक लॅब", desc: "Well-appointed lab with multiple workstations, projector and networked systems for practical sessions." },
  { title: "Well-equipped Library", mr: "सुसज्ज ग्रंथालय", desc: "Technical reference books, syllabus manuals, competitive-exam material and journals for trainees." },
  { title: "Engineering Drawing Hall", mr: "सुसज्ज इंजिनिअरिंग ड्रॉईंग हॉल", desc: "Dedicated drawing hall with individual boards for machine and electrical drawing practicals." },
  { title: "Trade Workshops", mr: "व्यवसाय कर्मशाळा", desc: "Fully-equipped workshops for Electrician, Fitter, Mechanic Motor Vehicle and Mechanic Diesel trades." },
  { title: "Employment & Self-Employment Cell", mr: "रोजगार-स्वयंरोजगार मार्गदर्शन केंद्र", desc: "Placement guidance, self-employment counselling and mock interviews for outgoing trainees." },
];

export const FEATURES = [
  "All trade units affiliated with the Central Government (NCVT, New Delhi)",
  "Workshops equipped with modern machinery and tools",
  "Experienced and expert instructors across every trade",
  "Curriculum, examinations and certification identical to Government ITIs",
  "Employment & self-employment guidance for every batch",
  "Grand educational complex with generous open spaces",
];

export const OBJECTIVES = [
  "Supply skilled manpower required by industry for varied job roles",
  "Empower youth with training that makes them factory-ready",
  "Enable skill-based self-employment in manufacturing and services",
  "Support industry with quality, productivity and standards improvement",
];

// Small building blocks
export function PageHero({ eyebrow, title, sub }) {
  return (
    <div className="bg-gradient-to-r from-[#0F2A47] via-[#123055] to-[#0F2A47] text-white">
      <div className="max-w-6xl mx-auto px-5 py-12">
        {eyebrow && <div className="text-[10px] uppercase tracking-[0.35em] font-bold text-[#F97316]">{eyebrow}</div>}
        <h1 className="font-serif text-3xl sm:text-4xl mt-2 leading-tight">{title}</h1>
        {sub && <p className="mt-3 text-white/80 text-sm max-w-3xl">{sub}</p>}
      </div>
    </div>
  );
}

export function Section({ children, className = "" }) {
  return <section className={`max-w-6xl mx-auto px-5 py-14 ${className}`}>{children}</section>;
}
